import React from "react";
import {TableDateSearchProvider} from "../Context/TableDateSearchContext.jsx";
import {AdminOrders} from "./AdminOrders.jsx";

export const AdminOrdersWrapper = ({history}) => {
    return (
        <>
            <TableDateSearchProvider localStorageKey="adminOrdersSearchDate">
                <AdminOrders history={history} />
            </TableDateSearchProvider>
        </>
    );
};
